import { buildProps as o, definePropType as t } from "./index601.js";
import { mutable as s } from "./index612.js";
import { iconPropType as a } from "./index606.js";
import { isClient as n } from "./index599.js";
const l = [
  "primary",
  "success",
  "info",
  "warning",
  "error"
], p = [
  "top",
  "top-left",
  "top-right",
  "bottom",
  "bottom-left",
  "bottom-right"
], m = "top", e = s({
  customClass: "",
  dangerouslyUseHTMLString: !1,
  duration: 3e3,
  icon: void 0,
  id: "",
  message: "",
  onClose: void 0,
  showClose: !1,
  type: "info",
  plain: !1,
  offset: 16,
  placement: void 0,
  zIndex: 0,
  grouping: !1,
  repeatNum: 1,
  appendTo: n ? document.body : void 0
}), f = o({
  /**
   * @description custom class name for Message
   */
  customClass: {
    type: String,
    default: e.customClass
  },
  /**
   * @description whether `message` is treated as HTML string
   */
  dangerouslyUseHTMLString: {
    type: Boolean,
    default: e.dangerouslyUseHTMLString
  },
  /**
   * @description display duration, millisecond. If set to 0, it will not turn off automatically
   */
  duration: {
    type: Number,
    default: e.duration
  },
  /**
   * @description custom icon component, overrides `type`
   */
  icon: {
    type: a,
    default: e.icon
  },
  /**
   * @description message dom id
   */
  id: {
    type: String,
    default: e.id
  },
  /**
   * @description message text
   */
  message: {
    type: t([
      String,
      Object,
      Function
    ]),
    default: e.message
  },
  /**
   * @description callback function when closed with the message instance as the parameter
   */
  onClose: {
    type: t(Function),
    default: e.onClose
  },
  /**
   * @description whether to show a close button
   */
  showClose: {
    type: Boolean,
    default: e.showClose
  },
  /**
   * @description message type
   */
  type: {
    type: String,
    values: l,
    default: e.type
  },
  /**
   * @description whether message is plain
   */
  plain: {
    type: Boolean,
    default: e.plain
  },
  /**
   * @description set the distance to the top of viewport
   */
  offset: {
    type: Number,
    default: e.offset
  },
  /**
   * @description message placement position
   */
  placement: {
    type: String,
    values: p,
    default: e.placement
  },
  /**
   * @description message element zIndex value
   */
  zIndex: {
    type: Number,
    default: e.zIndex
  },
  /**
   * @description merge messages with the same content, type of VNode message is not supported
   */
  grouping: {
    type: Boolean,
    default: e.grouping
  },
  /**
   * @description The number of repetitions, similar to badge, is used as the initial number when used with `grouping`
   */
  repeatNum: {
    type: Number,
    default: e.repeatNum
  }
}), g = {
  destroy: () => !0
};
export {
  m as MESSAGE_DEFAULT_PLACEMENT,
  e as messageDefaults,
  g as messageEmits,
  p as messagePlacement,
  f as messageProps,
  l as messageTypes
};
